import React, { Component } from "react";
import './ConversationStyleSheet.css';
import ActivityIndicator from "../CommonUtils/ActivityIndicator";
import fileimg from '../../images/file.png';
import closeimg from '../../images/close-window.png';


class PreviewAttachmentFiles extends Component {

    render() {
        let attachemntFiles = this.props.files || [];
        let color = (this.props.config.designDetails.headerColor || "#000000").split("#")[1];
        return (
        <>
        <div className="s360-preview-message-container" /*style={{ borderColor: this.props.config.designDetails.headerColor }}*/>
            {attachemntFiles.map(file => {
                if (!file.type) { return <></> }
                let fileURL = URL.createObjectURL(file);
                let isAudioFile = file.type.toLowerCase().indexOf("audio/") !== -1;
                let isVideoFile = file.type.toLowerCase().indexOf("video/") !== -1;
                let isImageFile = file.type.toLowerCase().indexOf("image/") !== -1;
                if (isAudioFile) {
                    return (
                        <div  style={{  backgroundColor: this.props.config.designDetails.headerColor }}>
                           <div className="s360-preview-close" onClick={() => { this.onRemoveClick(file); }} > <img className="s360-preview-box-close-image" objectFit="contain" width="25px" src={closeimg}/> </div>
                            <figure style={{ minWidth: "130px", width:"100%", height: "80px", display: "flex" }}>
                                <audio style={{ minWidth: "130px", width:"100%", alignSelf: "center",paddingLeft:"10px", paddingRight:"10px" }} controls src={fileURL}> Your browser does not support the <code>audio</code> element.
                                </audio>
                            </figure>
                        </div>)
                } else if (isVideoFile) {
                    return (
                        <div  style={{ backgroundColor: this.props.config.designDetails.headerColor }}>
                            <div className="s360-preview-close" onClick={() => { this.onRemoveClick(file); }} > <img className="s360-preview-box-close-image" objectFit="contain" width="25px" src={closeimg}/> </div>
                            <video controls width="180" style={{marginTop: "25px"}} >
                                <source src={fileURL} type="video/mp4" /> Sorry, your browser doesn't support embedded videos.
                       </video>
                        </div>)
                } if (isImageFile) {
                    return (
                        <div style={{ backgroundColor: this.props.config.designDetails.headerColor }}>
                            <div className="s360-preview-close" onClick={() => { this.onRemoveClick(file); }} > <img className="s360-preview-box-close-image" objectFit="contain" width="25px" src={closeimg}/> </div>
                            <img width="130px" height="100px" style={{marginTop: "25px"}} src={fileURL} alt="" />
                        </div>)
                } else {
                    return (<div style={{ backgroundColor: this.props.config.designDetails.headerColor }}>
                        <div className="s360-preview-close" onClick={() => { this.onRemoveClick(file); }} > <img className="s360-preview-box-close-image" objectFit="contain" width="25px" src={closeimg}/> </div>
                        <a target="_blank" href={fileURL} download>
                            <img width="100" height="100" style={{marginTop: "25px"}} title={fileURL} src={fileimg}></img>
                        </a>
                    </div>)
                }
            })}
        {this.props.isLoading && (<ActivityIndicator />)}
        </div>
        </>)
    }

    onRemoveClick = (file) => {
        this.props.onRemovePreviewFile(file);
    }
}

export default PreviewAttachmentFiles;